/* eslint-disable */
import { createSelector } from 'reselect';
import { ICommisionsState } from '../reducers/Commission';
import { IStore } from '../store';

export const selectCommissions = createSelector(
  (store: IStore) => store.commission,
  (commissionStore: ICommisionsState) => commissionStore
);
